import React from 'react';
import './assets/css/documentation.css';

class Documentation extends React.Component {
    render(){
        return(
        <div className="documentation" id="documentation">
            <div className="list">
            <br></br>
            <ul>
              <h3 id="title-type-moderation">Moderation</h3>
                    <li>
                        <a id="command">Ban</a>
                        <ul>
                            <li>Ban a member from the guild.
                                <ul>
                                    <li>ban <a id="args-commands">@user</a> <a id="args-commands">reason</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">UnBan</a>
                        <ul>
                            <li>UnBan a member.
                                <ul>
                                    <li>unban <a id="args-commands">case id</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Kick</a>
                        <ul>
                            <li>Kick a member from the guild.
                                <ul>
                                    <li>kick <a id="args-commands">@user</a> <a id="args-commands">reason</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Mute</a>
                        <ul>
                            <li>Mute a member from the guild.
                                <ul>
                                    <li>mute <a id="args-commands">@user</a> <a id="args-commands">reason</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">UnMute</a>
                        <ul>
                            <li>UnMute a member from the guild.
                                <ul>
                                    <li>unmute <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Banneds</a>
                        <ul>
                            <li>See how many users has been banneds from actual guild.
                                <ul>
                                    <li>banneds</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
              
                    <li>
                        <a id="command">Clear</a>
                        <ul>
                            <li>Delete message from the chat.
                                <ul>
                                    <li>clear <a id="args-commands">1-100 lines</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
              <h3 id="title-type-config">Configuration</h3>
              
                    <li>
                        <a id="command">Setup Prefix</a>
                        <ul>
                            <li>Setup the prefix, this to make it more comfortable or not interrupt with another bot.
                                <ul>
                                    <li>setprefix <a id="args-commands">prefix</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Setup Log Channel</a>
                        <ul>
                            <li>Setup the channel where all bot logs will go (Moderation, Edited Message, ETC).
                                <ul>
                                    <li>setlogs <a id="args-commands">#channel</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Disable Log Channel</a>
                        <ul>
                            <li>Disable log channel, If you want to setup the channel again you have to set setup again.
                                <ul>
                                    <li>setlogs <a id="args-commands">#channel</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

            
                <h3 id="title-type-ut">Utilities</h3>

                    <li>
                        <a id="command">Avatar</a>
                        <ul>
                            <li>Show your avatar of another user.
                                <ul>
                                    <li>avatar <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Server Info</a>
                        <ul>
                            <li>Show information about the guild.
                                <ul>
                                    <li>serverinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">User Info</a>
                        <ul>
                            <li>Show information about your or another user.
                                <ul>
                                    <li>userinfo <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Bot Info</a>
                        <ul>
                            <li>Show information about the bot.
                                <ul>
                                    <li>botinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Ping</a>
                        <ul>
                            <li>Show your status connection.
                                <ul>
                                    <li>ping</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Say</a>
                        <ul>
                            <li>Say anything in name bot.
                                <ul>
                                    <li>say <a id="args-commands">message</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-random">Random</h3>

                    <li>
                        <a id="command">Random Cat</a>
                        <ul>
                            <li>Watch a random cat image.
                                <ul>
                                    <li>cat</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Dog</a>
                        <ul>
                            <li>Watch a random dog image.
                                <ul>
                                    <li>dog</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Meme</a>
                        <ul>
                            <li>Watch a random meme.
                                <ul>
                                    <li>meme</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random  Pikachu</a>
                        <ul>
                            <li>Watch a random image of Pikachu.
                                <ul>
                                    <li>pika</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Panda</a>
                        <ul>
                            <li>Watch a random panda image.
                                <ul>
                                    <li>serverinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Koala</a>
                        <ul>
                            <li>Watch a random koala image.
                                <ul>
                                    <li>serverinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Wink</a>
                        <ul>
                            <li>Watch a random wink image.
                                <ul>
                                    <li>serverinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Fox</a>
                        <ul>
                            <li>Watch a random fox image.
                                <ul>
                                    <li>serverinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Bird</a>
                        <ul>
                            <li>Watch a random bird image.
                                <ul>
                                    <li>serverinfo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Random Fact</a>
                        <ul>
                            <li>Show information about of the world.
                                <ul>
                                    <li>fact</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <h3 id="title-type-games">Games</h3>

                    <li>
                        <a id="command">Pokedex</a>
                        <ul>
                            <li>Show information about a pokemon.
                                <ul>
                                    <li>pokedex <a id="args-commands">pokemon</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Minecraft Server Information</a>
                        <ul>
                            <li>Show information about a Minecraft server.
                                <ul>
                                    <li>mcserver <a id="args-commands">ip server</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Watch Minecraft Item</a>
                        <ul>
                            <li>Watch the image of item from Minecraft.
                                <ul>
                                    <li>item <a id="args-commands">item</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Watch Minecraft Head Player</a>
                        <ul>
                            <li>Watch the image of head of players Minecraft.
                                <ul>
                                    <li>head <a id="args-commands">nickname</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Watch Minecraft Skin Player</a>
                        <ul>
                            <li>Watch the image of skin of players Minecraft.
                                <ul>
                                    <li>skin <a id="args-commands">nickname</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Watch Hypixel Stats Player</a>
                        <ul>
                            <li>Show information about of player in Hypixel.
                                <ul>
                                    <li>hystats <a id="args-commands">nickname</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-random">Fun</h3>

                    <li>
                        <a id="command">Random Percentage of Love</a>
                        <ul>
                            <li>Watch your love with another player.
                                <ul>
                                    <li>love <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Random Percentage of Your Level Waifu</a>
                        <ul>
                            <li>Watch your level of Waifu.
                                <ul>
                                    <li>waifu</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">PVP with another player</a>
                        <ul>
                            <li>Fight with another player simulation a Minecraft fight.
                                <ul>
                                    <li>pvp <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Drugs...</a>
                        <ul>
                            <li>Guess it.
                                <ul>
                                    <li>drugs</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Swim</a>
                        <ul>
                            <li>You don't know how to swim, at least try the command?
                                <ul>
                                    <li>swim</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Trash</a>
                        <ul>
                            <li>Insult someone, come on do it.
                                <ul>
                                    <li>trash</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-inte">Interaction</h3>
      
                    <li>
                        <a id="command">Lick a player</a>
                        <ul>
                            <li>Lick a player (This is rare).
                                <ul>
                                    <li>lick <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Stabbing a player</a>
                        <ul>
                            <li>Release all your fury.
                                <ul>
                                    <li>stabbing <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Love</a>
                        <ul>
                            <li>It shows the percentage of people's love (<a id="args-commands">Available two users</a>).
                                <ul>
                                    <li>love <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Hack</a>
                        <ul>
                            <li>Hack a person and get their nudes.
                                <ul>
                                    <li>hack <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Kiss</a>
                        <ul>
                            <li>Kiss a person and show your love.
                                <ul>
                                    <li>kiss <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Kill</a>
                        <ul>
                            <li>Kill a person that doesn't leave you alone.
                                <ul>
                                    <li>Kill <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Pat</a>
                        <ul>
                            <li>Pat a person in absolute peace.
                                <ul>
                                    <li>Pat <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>  
              
                    <li>
                        <a id="command">Idiot</a>
                        <ul>
                            <li>Call a person idiot.
                                <ul>
                                    <li>idiot <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>  
              
                    <li>
                        <a id="command">Laught</a>
                        <ul>
                            <li>Laugh at a person's stupidities.
                                <ul>
                                    <li>laught <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>  
              
                    <li>
                        <a id="command">Scared</a>
                        <ul>
                            <li>Scared a person .
                                <ul>
                                    <li>scared <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>  
              
                    <li>
                        <a id="command">Hug a player</a>
                        <ul>
                            <li>Show love for a person.
                                <ul>
                                    <li>hug <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Ignore a Player</a>
                        <ul>
                            <li>Byeeee... B1tch
                                <ul>
                                    <li>ignore <a id="args-commands">@user</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-reaction">Roleplay</h3>

                    <li>
                        <a id="command">Cry</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>cry</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Happy</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>happy</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Angry</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>angry</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Confused</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>confused</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Bored</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>bored</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Blush</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>blush</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Disgust</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>disgust</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Nope</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>nope</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Vomit</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>vomit</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">FBI</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>fbi</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Sleep</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>sleep</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Frusted</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>Frusted</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Frusted</a>
                        <ul>
                            <li>React in chat with images.
                                <ul>
                                    <li>Frusted</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Random NSFW</a>
                        <ul>
                            <li>Watch a random nsfw image.
                                <ul>
                                    <li>nsfw</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                  <h3 id="title-type-nsfw">NSFW</h3>
              
                    <li>
                        <a id="command">Pussy</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>pussy</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Neko</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>neko</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Cum</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>cum</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Hentai</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>Hentai</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Blowjob</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>blowjob</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Small Boobs</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>smallboobs</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Holoero</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>holoero</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Spank</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>spank</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Eron</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>eron</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Waifu Nsfw</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>waifunsfw</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Solo</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>solo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Futunari</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>futunari</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Anal</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>anal</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Yuri</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>yuri</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                      
                    <li>
                        <a id="command">Holo</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>holo</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
              
                    <li>
                        <a id="command">Tits</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>tits</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Kuni</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>kuni</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Feet</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>feet</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Lewdk</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>lewdk</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">Keta</a>
                        <ul>
                            <li>Find out for yourself on an nsfw channel.
                                <ul>
                                    <li>Keta</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                    <li>
                        <a id="command">NSFW</a>
                        <ul>
                            <li>Random nsfw image.
                                <ul>
                                    <li>nsfw</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-social">Social</h3>
              
                    <li>
                        <a id="command">Instagram</a>
                        <ul>
                            <li>Look at the instagram profile of a person (@username).
                                <ul>
                                    <li>instagram <a id="args-commands">username</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-text">Text</h3>
                    
                    <li>
                        <a id="command">Doot</a>
                        <ul>
                            <li>Only a text style with emojis.
                                <ul>
                                    <li>doot <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Spoiler</a>
                        <ul>
                            <li>Click and surprise yourself.
                                <ul>
                                    <li>spoiler <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Bold Style</a>
                        <ul>
                            <li>Markdown style in name of bot.
                                <ul>
                                    <li>bold <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                
                    <li>
                        <a id="command">Italics Style</a>
                        <ul>
                            <li>Markdown style in name of bot.
                                <ul>
                                    <li>italics <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Underline Style</a>
                        <ul>
                            <li>Markdown style in name of bot.
                                <ul>
                                    <li>underline <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
        
                    <li>
                        <a id="command">Bold + Underline Style</a>
                        <ul>
                            <li>Markdown style in name of bot (Bold + Underline).
                                <ul>
                                    <li>boldline <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Bold + Italics Style</a>
                        <ul>
                            <li>Markdown style in name of bot (Bold + Italics).
                                <ul>
                                    <li>boldlics <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    
                    <li>
                        <a id="command">Strike Style</a>
                        <ul>
                            <li>Markdown style in name of bot.
                                <ul>
                                    <li>strike <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
            
                    <li>
                        <a id="command">All Styles</a>
                        <ul>
                            <li>Markdown style in name of bot (Bold + Italics + Underline + Strike).
                                <ul>
                                    <li>all <a id="args-commands">text</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
                  <h3 id="title-type-bot">Bot</h3>

                    <li>
                        <a id="command">Bot Support</a>
                        <ul>
                            <li>Get support from the bot.
                                <ul>
                                    <li>botsupport</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Bug Report</a>
                        <ul>
                            <li>Report a bug related with bot.
                                <ul>
                                    <li>bugreport <a id="args-commands">title</a>/<a id="args-commands">description</a></li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Stats Bot</a>
                        <ul>
                            <li>See stats from bot.
                                <ul>
                                    <li>stats</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Web</a>
                        <ul>
                            <li>Get this web.
                                <ul>
                                    <li>web</li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <a id="command">Help</a>
                        <ul>
                            <li>Watch the list commands.
                                <ul>
                                    <li>help</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
              
              <h4 id="separator-commands">.</h4>
            </ul> 
            </div>
        </div>
        )
    };
}

export default Documentation;